var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { attrs: { cols: "10", sm: "8" } },
    [
      _c("h3", { staticClass: "title-login grey-text bold text-darken-2" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("account.resetPassword")) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle-login grey-text" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("account.passwordEmailSent", { emailSentTo: _vm.email })
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { id: "password-sent-form" },
          on: {
            submit: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
            },
          },
        },
        [
          _c("input", {
            staticClass: "d-none",
            attrs: { id: "email", type: "email" },
            domProps: { value: _vm.email },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "d-none", attrs: { for: "email" } }, [
            _vm._v("email"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "forgot-form" } },
            [
              _c("input", {
                staticStyle: {
                  position: "fixed",
                  top: "-100px",
                  left: "-100px",
                  width: "5px",
                },
                attrs: {
                  id: "fake-username-input",
                  type: "text",
                  name: "fakeusername",
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "d-none",
                  attrs: { for: "fake-username-input" },
                },
                [_vm._v("fakeUsername")]
              ),
              _vm._v(" "),
              _c("input", {
                staticStyle: {
                  position: "fixed",
                  top: "-100px",
                  left: "-100px",
                  width: "5px",
                },
                attrs: {
                  id: "fake-password-input",
                  type: "password",
                  name: "fakepassword",
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "d-none",
                  attrs: { for: "fake-password-input" },
                },
                [_vm._v("fakePassword")]
              ),
              _vm._v(" "),
              _c(
                "material-input",
                {
                  staticClass: "mx-auto",
                  attrs: {
                    id: "code",
                    "client-login": "",
                    "required-indicator": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "input-icon",
                      fn: function () {
                        return [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              attrs: { id: "code-icon" },
                            },
                            [_vm._v("qr_code")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.code,
                    callback: function ($$v) {
                      _vm.code = $$v
                    },
                    expression: "code",
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.code,
                        expression: "code",
                      },
                    ],
                    attrs: {
                      id: "code-textarea",
                      type: "text",
                      placeholder: _vm.$t("global.words.code"),
                      "no-auto-complete": "",
                    },
                    domProps: { value: _vm.code },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "d-none", attrs: { for: "code-textarea" } },
                    [_vm._v("code")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("password-input", {
                staticClass: "mx-auto",
                attrs: {
                  id: "password",
                  "custom-expression": "password",
                  "client-login": "",
                  password: _vm.password,
                  "validator-context": _vm.$v,
                  placeholder: _vm.$t("account.password"),
                  disabled: _vm.loading,
                  type: "primary",
                  "required-indicator": "",
                  "on-type": "",
                },
                on: {
                  "update:password": function ($event) {
                    _vm.password = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("password-input", {
                staticClass: "mx-auto",
                attrs: {
                  id: "password",
                  "custom-expression": "password",
                  "client-login": "",
                  password: _vm.passwordRepeat,
                  placeholder: _vm.$t("account.reEnterPassword"),
                  "validator-context": _vm.$v,
                  disabled: _vm.loading,
                  type: "primary",
                  "required-indicator": "",
                  "on-type": "",
                },
                on: {
                  "update:password": function ($event) {
                    _vm.passwordRepeat = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "justify-content-center",
              attrs: { id: "forgot-form" },
            },
            [
              _c(
                "simple-button",
                {
                  attrs: {
                    disabled: !_vm.isValid,
                    "class-name": "rounded-pill py-2 px-5",
                    loading: _vm.loading,
                    "loading-succeeded": _vm.loadingStatus,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("account.resetPassword")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { staticClass: "footer-login", attrs: { cols: "12" } }, [
        _c("p", { staticClass: "grey-text center" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("account.didntReceiveIt")) + "\n      "
          ),
          _c(
            "a",
            {
              staticClass: "clickable",
              class: { disabled: _vm.resendingCode },
              attrs: { id: "resent-email" },
              on: { click: _vm.resendCode },
            },
            [
              _vm.resendingCode ? _c("inline-loader") : _vm._e(),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("account.resendEmail")) +
                  "\n      "
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }